import React from 'react';
import './styles.css';

export const TooltipData = ({ geo }) => {



    const renderPaymentMethods = () => {
        return (
            <div className="payment-root">
                {
                    geo?.payments?.payments.map(p => {
                        return (
                            <div key={p.id} className="payment-pill">
                                {p.name}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    let countryCode = geo?.properties['Alpha-2']?.toLowerCase();
    if (!countryCode) {
        if (geo?.properties['name'] === 'South Sudan') {
            countryCode = 'ss';
        }
        if (geo?.properties['name'] === 'Somaliland') {
            countryCode = 'somaliland';
        }
    }

    return (
        <div className="tooltip-root">
            <div className="tooltip-header">
                <img alt={geo?.properties['Alpha-2']} className="tooltip-country-img" src={`https://hatscripts.github.io/circle-flags/flags/${countryCode}.svg`}></img>
                <p style={{ padding: '0px', margin: '0px', marginBottom: '0', fontSize: '1.2rem', fontWeight: 'bold' }}>{geo?.properties?.name}</p>
            </div>
            <p style={{ padding: '0px', fontSize: '1rem', marginBottom: '16px', color: '#5F6560' }}>
                Payment Methods
            </p>
            {renderPaymentMethods()}
            <p style={{ padding: '0px', fontSize: '1rem', marginBottom: '0.5rem', color: '#595959' }}>
                No of onramps
            </p>
            <div className="tooltip-number">
                <p style={{ padding: '0px', margin: '0', fontSize: '0.8rem', color: '#595959' }}>
                    {`${geo?.onrampCount}`}
                </p>
            </div>
        </div>
    );
}